export const paginationSize = 25;
export const lithiumUnCodeList: string[] = ["3090", "3091", "3480", "3481"];

export type LabelFormatType = "Pdf" | "Zebra";

export type ParcelDocumentType = "PdfLabel203dpi" | "ZebraLabel203dpi" | "PreparationOrder" | "LabelAndPreparationOrderOnSamePage" | "LabelAndPreparationOrderOnConsecutivePages" | "DeliverySlip";

export type ParcelBulkCreationMode = "OneParcelPerOrder" | "OneParcelPerProductItem" | "OneParcelPerOrderWithMonoRef" | "OneParcelPerOrderWithMultiRef" | "OneParcelPerComponentProduct" | "OneParcelPerProductWithMonoParcelFlag";

export type LocaleType = "en-GB" | "fr-FR" | "es-ES" | "it-IT" | "de-DE" | "pl-PL";

export type HttpMethodType = "GET" | "GETLIST" | "POST" | "PUT" | "PATCH" | "DELETE";

export type PrinterExtensionType = "Pdf" | "Zpl";
export type PrinterPaperFormat = "A4" | undefined;
export const printerExtensionList: PrinterExtensionType[] = ["Pdf", "Zpl"];

export function getPrinterExtension(labelFormat: LabelFormatType): PrinterExtensionType {
    if (labelFormat === "Pdf") {
        return "Pdf";
    }
    if (labelFormat === "Zebra") {
        return "Zpl";
    }
    return "Pdf";
}

export function getPrinterLabelExtension(printerExtensionType: PrinterExtensionType): string {
    if (printerExtensionType === "Pdf") {
        return "Pdf";
    }
    if (printerExtensionType === "Zpl") {
        return "Zpl (Zebra)";
    }
    return "Pdf";
}

export function getLabelFormat(printerExtensionType: PrinterExtensionType): LabelFormatType {
    if (printerExtensionType === "Pdf") {
        return "Pdf";
    }
    if (printerExtensionType === "Zpl") {
        return "Zebra";
    }
    return "Pdf";
}

export type NotificationKeyType = "QzConnection";

export type LogicConstraintType = "Unspecified" | "MAX_SUM_L_W_H" | "MAX_SUM_2L_2W_H" | "MAX_SUM_L_2W_H" | "MAX_SUM_2L_W_H" | "MAX_SUM_2L_2W_2H" | "MAX_SUM_L_W_2H" | "MAX_SUM_L_2W_2H";

export type DeliveryOrderStatusType = "Available" | "Cancelled" | "Parcelled" | "Labeled" | "Shipped";

export const roleAdmin: UserRoleType = "Administrator";
export const roleSuperAdmin: UserRoleType = "SuperAdministrator";
export const roleSupplier: UserRoleType = "Supplier";
export const roleSrmAgent: UserRoleType = "SrmAgent";
export const roleSupervisor: UserRoleType = "Supervisor";
export const roleMerchant: UserRoleType = "Merchant";
export const roleInternalService: UserRoleType = "Service";
export const roleReadyToShipFeature: FeatureRoleType = "FeatureReadyToShip";
export const roleBlueBrand: FeatureRoleType = "FeatureBlueBrand";
export const roleExposeShippingAddress: FeatureRoleType = "FeatureExposeShippingAddress";
export const rolePalletPickUpForm: FeatureRoleType = "FeaturePalletPickUpForm";
export const rolePalletWorkflow: FeatureRoleType = "FeaturePalletWorkflow";
export const roleFeatureManageOperationAccess: FeatureRoleType = "FeatureManageOperationAccess";
export const roleFeatureEnablingMasterBoxPalletType: FeatureRoleType = "FeatureEnablingMasterBoxPalletType";
export const roleFeatureEnablingTruckPalletType: FeatureRoleType = "FeatureEnablingTruckPalletType";
export const roleFeatureEnableAutomaticShippingSeenParcels: FeatureRoleType = "FeatureEnableAutomaticShippingSeenParcels";
export const roleFeatureEnableAutomaticShippingCrossdockSeenParcels: FeatureRoleType = "FeatureEnableAutomaticShippingCrossdockSeenParcels";
export const roleBiDataExtractor: UserRoleType = "BiDataExtractor";
export const roleReadOnlyIntegrator: UserRoleType = "ReadOnlyIntegrator";
export const roleFeatureParcelStockout: FeatureRoleType = "FeatureParcelStockouts";
export const roleFeaturePreserveParcelTrackerOnUpdate: FeatureRoleType = "FeaturePreserveParcelTrackerOnUpdate";
export const rolePalletPickupSlotShipping: FeatureRoleType = "PalletPickupSlotShipping";
export const roleUserDataValidation: FeatureRoleType = "FeatureUserDataValidation";
export const roleFeatureEnableBTMReturns: FeatureRoleType = "FeatureEnableBTMReturns";

export type UserRoleType = "SuperAdministrator" | "Administrator" | "Supplier" | "SrmAgent" | "Supervisor" | "Merchant" | "Service" | "BiDataExtractor"| "ReadOnlyIntegrator";
export type FeatureRoleType = "FeatureReadyToShip" | "FeatureBlueBrand" | "FeatureExposeShippingAddress"
    |"FeaturePalletPickUpForm" | "FeaturePalletWorkflow" | "FeatureMondialRelayMixedPalletsAll"
    | "FeatureMondialRelayMixedPalletsFR_BNL_IT" | "FeatureMixedPalletsAny" | "FeatureManageOperationAccess"
    | "FeatureEnablingProductPricing" | "FeatureParcelStockouts" | "FeatureEnablingMasterBoxPalletType"
    | "FeatureEnablingTruckPalletType" | "FeatureEnableAutomaticShippingSeenParcels" | "FeatureEnableAutomaticShippingCrossdockSeenParcels"
    | "FeaturePreserveParcelTrackerOnUpdate" | "PalletPickupSlotShipping" | "FeatureUserDataValidation"
    | "FeatureEnableBTMReturns";
export type UserAttribute = "ClickAndShipUser" | "ApiUser" | "ScanAndShipUser";

export type AuthScheme = "sso" | "ds" | "none";

export const A4LandscapePrinterConfig = {
    orientation: "landscape",
    margins: 0.25,
    size: navigator.platform.toLowerCase().indexOf("mac") >= 0 ? undefined : {
        width: 8.27,
        height: 11.69,
    },
};

export const A4AutoPrinterConfig = {
    margins: 0,
    size: {
        width: 8.27,
        height: 11.69,
    },
};

export type PanelMenuType = "OPERATION_PREPARATION" | "PALLET_PREPARATION" | "OTHERS" | "BTM_RETURNS" | "ADMINISTRATION";

export enum DangerousGoods {
    None,
    Lithium = "Lithium",
    LiquidQuantity = "Liquid Quantity",
    Both = "Liquid Quantity, Lithium",
}
